import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import React from 'react'

interface SectionCardProps {
  title: string
  description?: string
  defaultOpen?: boolean
  children: React.ReactNode
  badge?: string
  unmount?: boolean
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  defaultOpen = true,
  children,
  badge,
  unmount = true,
}) => {
  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <div className="w-full rounded-lg border border-gray-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800">
          <Disclosure.Button className="flex w-full items-start justify-between gap-3 p-6 text-left transition hover:bg-gray-50/60 dark:hover:bg-slate-700/30">
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                  {title}
                </h4>
                {badge && (
                  <span className="rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 dark:bg-blue-900/40 dark:text-blue-200">
                    {badge}
                  </span>
                )}
              </div>
              {description && (
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  {description}
                </p>
              )}
            </div>
            <ChevronDownIcon
              className={`mt-0.5 h-5 w-5 shrink-0 text-gray-400 transition-transform ${
                open ? 'rotate-180' : ''
              }`}
            />
          </Disclosure.Button>

          <Disclosure.Panel unmount={unmount} className="border-t border-gray-200 px-6 pb-6 pt-4 dark:border-slate-700">
            {children}
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  )
}

export default SectionCard
